import { render } from "./LoadingObjet.vue?vue&type=template&id=8e64cb82"
import script from "./LoadingObjet.vue?vue&type=script&lang=js"
export * from "./LoadingObjet.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__